import React from "react";
import { View } from "react-native";
import { zodResolver } from "@hookform/resolvers/zod";
import { FormProvider, useForm } from "react-hook-form";
import { z } from "zod";

import { RenderSpace } from "~/components/SaveForm/SaveForm.selectLocation";
import { backlogSlug } from "~/app/(app)/(authenticated)/[account]/(account)/backlog";
import { useAccountStore } from "~/stores/space";
import { Button } from "~/ui/Button";
import { ListContainer } from "~/ui/List";

const schema = z.object({
  location: z.record(z.record(z.boolean())),
});

type FormValues = z.infer<typeof schema>;

export type MoveSaveFormProps = {
  srcSpaceId: string;
  saveIds: Array<string>;
  onSuccess: () => void;
};

export function MoveSaveForm({
  srcSpaceId,
  saveIds,
  onSuccess,
}: MoveSaveFormProps) {
  const { store } = useAccountStore();

  const isSourceBacklog = store.spaceById(srcSpaceId)?.slug === backlogSlug;

  const form = useForm<FormValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      location: {},
    },
  });

  const spaceWithoutSelf = store.spacesAsArrayWithoutBacklog.filter((space) => {
    if (space.id === srcSpaceId) return false;
    return true;
  });

  return (
    <FormProvider {...form}>
      <View className="container gap-2">
        {!isSourceBacklog && (
          <ListContainer>
            <RenderSpace spaceId={store.spaceBySlug(backlogSlug)?.id ?? ""} />
          </ListContainer>
        )}

        {spaceWithoutSelf.length > 0 && (
          <ListContainer>
            {spaceWithoutSelf.map((space) => {
              return <RenderSpace key={space.id} spaceId={space.id} />;
            })}
          </ListContainer>
        )}
        <View />
        <View />

        <Button
          onPress={form.handleSubmit((data) => {
            saveIds.forEach((saveId) => {
              for (const targetSpaceId in data.location) {
                store.moveSave({
                  saveId,
                  sourceSpaceId: srcSpaceId,
                  targetSpaceId,
                });
              }
            });

            onSuccess();
          })}
        >
          Move save
        </Button>
      </View>
    </FormProvider>
  );
}
